// vertical-gallery/client.js
// Logic for vertical-gallery display and interactions
import $ from 'jquery';
import radio from 'radio';
import {
  SCROLL,
  RESIZE,
} from 'shared/enums/events';

const $window = $(window);

class Gallery {
  constructor($context) {
    this.$context = $context;
    this.galleryScroll = this.galleryScroll.bind(this);
    this.addHandlers = this.addHandlers.bind(this);
    this.render = this.render.bind(this);
    this.activeHash = '';
    this.scrollDirection = 'down';
    this.oldScrollY = 0;

    if (this.$context.is(':visible')) {
      // Start-state when V Gallery is initially in view.
      this.initialHash = (document.location.hash.length > 1) ? document.location.hash.substring(1) : '';
      this.enableHash = (this.initialHash === '');
    } else {
      // Start-state when H Gallery is initially in view.
      this.initialHash = '';
      this.enableHash = true;
    }
  }

  render() {
    this.initHash();
    this.addHandlers();
  }

  initHash() {
    if (this.initialHash !== '') {
      const $anchor = $(`[name=${this.initialHash}]`);
      
      if ($anchor.length) {
        (document.body).animate({
          scrollTop: $anchor.offset().top,
        });
      }
    }
    this.enableHash = true;
  }

  addHandlers() {
    radio(SCROLL).subscribe(this.galleryScroll);
    radio(RESIZE).subscribe(this.galleryScroll);
  }

  galleryScroll() {
    // Ignore while H Gallery is in view.
    if (!(this.$context.is(':visible'))) {
      return;
    }

    const $slides = this.$context.find('.vertical-slide');
    const scrollTop = $window.scrollTop();
    const breakPoint = $window.height() / 2;
    let $active = $slides.filter('.active');
    if (this.oldScrollY > scrollTop) {
      this.scrollDirection = 'up';
    } else {
      this.scrollDirection = 'down';
    }
    this.oldScrollY = scrollTop;

    $slides.each((i, elem) => {
      const $this = $(elem);
      const offsetTop = $this.offset().top;

      if (offsetTop - scrollTop < breakPoint) {
        $active.removeClass('active');
        $active = $this;
      } else if ($this.is($active)) {
        $active = $([]);
      }
    });

    if ($active.length) {
      this.setActive($active);
    }
  }

  setActive($slide) {
    let hash = '';
    let slideNum = '';
    let headline = '';

    if ($slide.length > 0) {
      hash = String($slide.data('hash'));
      headline = $slide.data('headline');
      slideNum = String($slide.data('slide-index'));
      $slide.addClass('active');
    }

    if (hash === this.activeHash) {
      return false;
    }
    this.activeHash = hash;

    if (this.enableHash) {
      history.replaceState(undefined, undefined, (hash === '') ? '' : `#${hash}`);
      // To optimize gtm, we need hashchange event for gallery to trigger page view.
      window.dispatchEvent(new Event('hashchange'));
      const customEventData = {
        slideNumber: slideNum,
        slideName: headline,
        direction: this.scrollDirection,
      };
      window.dispatchEvent(new CustomEvent('galleryHashChange', { detail: customEventData }));
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        slideNumber: slideNum,
        slideName: headline,
        event: 'Gallery Slide Changed',
      });
    }

    return true;
  }
}

export default function () {
  return $('.component.vertical-gallery').each(function iterateGalleries() {
    return new Gallery($(this)).render();
  });
}



// WEBPACK FOOTER //
// ./~/unicorn/shared/components/vertical-gallery/client.js
